export type PlanTier = 'free' | 'individual' | 'school' | 'trust';
export type BillingStatus = 'trialing' | 'active' | 'past_due' | 'cancelled' | 'paused';
export type BillingScope = 'individual' | 'school' | 'trust';

export function isTrialing(status: BillingStatus | null): boolean {
  return status === 'trialing';
}

export function isActive(status: BillingStatus | null): boolean {
  return status === 'active' || status === 'trialing';
}

export function isTrustBilled(scope: BillingScope | null): boolean {
  return scope === 'trust';
}

export function isTrialExpired(trialEndsAt: string | null, billingStatus: BillingStatus | null): boolean {
  if (billingStatus !== 'trialing') return false;
  if (!trialEndsAt) return false;
  return new Date(trialEndsAt) < new Date();
}

export function isAccountBlocked(billingStatus: BillingStatus | null, trialEndsAt: string | null): boolean {
  if (!billingStatus) return false;
  if (billingStatus === 'cancelled' || billingStatus === 'paused') return true;
  if (isTrialExpired(trialEndsAt, billingStatus)) return true;
  return false;
}

export function getUpgradeReason(billingStatus: BillingStatus | null, trialEndsAt: string | null): string | null {
  if (!billingStatus) return null;
  if (billingStatus === 'cancelled') return 'Your subscription has been cancelled.';
  if (billingStatus === 'paused') return 'Your subscription has been paused.';
  if (isTrialExpired(trialEndsAt, billingStatus)) return 'Your free trial has ended.';
  if (billingStatus === 'past_due') return 'Your payment is past due.';
  return null;
}
